class CacheManager {
  constructor() {
    this.requests = {};

    /**
     * @type {Record<string, {
     * blob: string | null;
     * bitmap: ImageBitmap | null;
     * done: boolean } | undefined>}
     */
    this.cache = {};
  }

  /**
   * @param {string} url
   * @returns {{ blob: string | null;
   * bitmap: ImageBitmap | null;
   * done: boolean } | undefined}
   */
  get(url) {
    return this.cache[url];
  }

  /**
   * @param {string} url
   * @returns {boolean}
   */
  isReady(url) {
    return this.cache[url]?.done;
  }

  /**
   * @param {string} imageUrl
   * @param {boolean} [ignoreBitmap]
   * @returns {Promise<{ blob: string;
   * bitmap: ImageBitmap | null;
   * done: boolean }>}
   */
  async image(imageUrl, ignoreBitmap = false) {
    if (this.requests[imageUrl]) {
      return this.requests[imageUrl];
    }

    const request = fetch(imageUrl, {
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Accept: "image/jpeg,*/*;q=0.8",
      },
    }).then((res) => res.blob());

    this.cache[imageUrl] = {
      blob: null,
      bitmap: null,
      done: false,
    };

    const promises = [request.then((blob) => URL.createObjectURL(blob))];

    if (!ignoreBitmap) {
      promises.push(request.then((blob) => createImageBitmap(blob)));
    }

    const allDone = Promise.all(promises).then(([blobUrl, bitmap]) => {
      const entry = this.cache[imageUrl];

      entry.blob = blobUrl;

      if (!ignoreBitmap) {
        entry.bitmap = bitmap;
      }

      entry.done = true;

      return entry;
    });

    this.requests[imageUrl] = allDone;

    return allDone;
  }
}

export default CacheManager;
